export default __webpack_public_path__ + "static/media/Nose_2.cdb2dfe3.svg";